import { render } from "./LoadingText.vue?vue&type=template&id=ccab19ea&scoped=true"
import script from "./LoadingText.vue?vue&type=script&lang=js"
export * from "./LoadingText.vue?vue&type=script&lang=js"

import "./LoadingText.vue?vue&type=style&index=0&id=ccab19ea&scoped=true&lang=css"

import exportComponent from "/Users/victoriengarrigues/Documents/Moonarch-DEV/code/moonarch-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccab19ea"]])

export default __exports__